///
/// EarthBrowser
///
/// Created by Matt Giger on 10/29/2026
/// Copyright (c) 2026 Geodata Labs
///
/// v56 -> v57: Add userInterface.layersPanel (collapsed catalog groups in
/// the Layers panel). Nothing to carry over: the previous panel had no
/// collapsible groups, so every group starts open.
///

export function migrateV56toV57(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object") return state

	const userInterface = s.userInterface as Record<string, unknown> | undefined
	if (!userInterface || userInterface.layersPanel) return state

	return {
		...s,
		userInterface: {
			...userInterface,
			layersPanel: { collapsedGroups: [] },
		},
	}
}
